import { render, staticRenderFns } from "./risk_detection.vue?vue&type=template&id=6eb79286&scoped=true&"
import script from "./risk_detection.vue?vue&type=script&lang=js&"
export * from "./risk_detection.vue?vue&type=script&lang=js&"
import style0 from "./risk_detection.vue?vue&type=style&index=0&id=6eb79286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb79286",
  null
  
)

export default component.exports